module.exports = __webpack_public_path__ + "static/broadcaster_sec4-4ce5c32f4dfe3cb7eab0e508b253df66.png";